// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles_checkboxWrapper__IUxkK","dot":"styles_dot__q6BDY","active":"styles_active__SAiha"};